import React,  { Component } from 'react';
import Particles from 'react-particles-js';
import layout from './line';

export default class Particle extends Component {
  render() {
    return (
      <Particles className="particle" params={layout} style={{
        position: 'absolute',
        top: 0,
        left: 0
      }} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/particles/particles.js